import { FC, ReactNode } from 'react';

import clsx from 'clsx';

import styles from './NewsContainer.module.scss';

interface NewsContainerProps {
  children: ReactNode;
  className?: string;
}

const NewsContainer: FC<NewsContainerProps> = ({ children, className = '' }) => {
  const containerStyles: string = clsx({
    [styles.container]: true,
    [className]: className,
  });

  return <div className={containerStyles}>{children}</div>;
};

export default NewsContainer;
